export function isComposerSubmitShortcut({
  key,
  shiftKey,
  isComposing = false,
  sendBlocked = false,
}: {
  key: string;
  shiftKey: boolean;
  isComposing?: boolean;
  sendBlocked?: boolean;
}): boolean {
  return key === "Enter" && !shiftKey && !isComposing && !sendBlocked;
}
